import { Component, isDevMode } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { Observable, of } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { environment } from 'src/environments/environment';
import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';
import { switchMap } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'src/app/services/message/message.service';
import { SpinnerText } from 'src/app/services/message/message.enum';
import { GetTextPipe } from 'src/app/pipes';
import {UserLookupColumns} from '../permissions.component';

@Component({
  selector: 'permissions-report',
  templateUrl: './permissions-report.component.html',
  providers: [GetTextPipe]
})

export class PermissionsReportComponent {

  constructor(
    private transferHttp: TransferHttpService,
    public permissionsService: PermissionsService,
    private messageService: MessageService,
    private getTextPipe: GetTextPipe
  ) { }

  //***************************
  // Variables
  //***************************
  permissions: AimsCommonTablePermissions = {create:false,update:false,delete:false, export:true}
  currentUser = this.transferHttp.getCache('user');

  //Dropdown Values
  users = this.permissionsService.getUsers();
  groupValues;
  user:BehaviorSubject<any> = new BehaviorSubject({
    user: this.currentUser.loginName,
    userId: this.currentUser.userId
  });

  permissionsReport:Observable<any> = this.user.pipe(
    tap(() => {
      this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Load);
      this.showSpinner = true;
    }),
    switchMap(u => u? this.permissionsService.getPermissionsReport(u.userId):of(null)),
    tap(r => {
      this.permissionsReportDataSource = r;
      this.showSpinner = false;
    })
  );

  componentValues: Array<any>;
  components = this.permissionsService.getComponents().subscribe(ret => {
    this.componentValues = ret;
  });
  defaultComponent: { component: string, componentId: string } = { component: '---select---', componentId: null };

  //TODO: figure out how to bring back password exp after incorportating multi-tenant
  //passwordExp: Observable<number> = this.transferHttp.get(`https:////www.arctecalaska.com/Reports/api/Password/GetPasswordExpiration?user=${this.user.loginName}`);


  imgSrc: string = environment.assetsPath;
  //Spinner
  spinnerText: string = this.messageService.getSpinnerText(SpinnerText.Load);
  showSpinner: boolean = false;

  //Columns
  permissionsReportDataSource: any[];
  userLookupColumns = UserLookupColumns;

  permissionsReportColumns: AimsCommonTableHeader[] = [
    {
      key: 'componentId', label: 'Component', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) =>
        this.getTextPipe.transform(element.componentId, 'componentId', 'component', this.componentValues)
      }
    },
    {
      key: 'createProvider', label: 'Create Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) =>
        this.getTextPipe.transform(element.createProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues)
      }
     },
    { key: 'create', label: 'Create', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    {
      key: 'readProvider', label: 'Read Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) =>
        this.getTextPipe.transform(element.readProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues)
      }
    },
    { key: 'read', label: 'Read', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'updateProvider', label: 'Update Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) =>
        this.getTextPipe.transform(element.updateProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues)
      }
    },
    { key: 'update', label: 'Update', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'deleteProvider', label: 'Delete Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) =>
        this.getTextPipe.transform(element.deleteProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues)
      }
    },
    { key: 'delete', label: 'Delete', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 }
    ];
  //***************************
  // Functions
  //***************************

  handleUserLookupChange(element) {
    if(!element){
      this.user.next(null);
      return
    }
    this.user.next(element);
  }

  public excelReportName: string = 'Permissions_export.xlsx';

  getForExcel = (data: any) => {
    var exportData = data.map(element => {
      var x = {
        'componentId': this.getTextPipe.transform(element.componentId, 'componentId', 'component', this.componentValues),
        'createProvider': this.getTextPipe.transform(element.createProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues),
        'create': element.create,
        'readProvider': this.getTextPipe.transform(element.readProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues),
        'read': element.read,
        'updateProvider': this.getTextPipe.transform(element.updateProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues),
        'update': element.update,
        'deleteProvider': this.getTextPipe.transform(element.deleteProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues),
        'delete': element.delete,
      };
      return x;
    });

    return { 'data': exportData, 'fileName':  this.excelReportName  };
  }


  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Load);
    this.showSpinner = true;

    this.permissionsService.getPermissionGroups().subscribe(p => {
      this.groupValues = p;
      this.showSpinner = false;
    });
  }


}
